//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapMutations } from 'vuex';


export default {
  block: 'textLink',
  props: ['data','index'],
  computed: {
    text() {
      return this.data.text;
    },
    linkText() {
      return this.data.linkText;
    },
    externalLink() {
      return this.data.externalLink;
    },
    route() {
      return '/' + this.data.route;
    }
  },
  methods: {
    // Always close mobile menu when link is clicked
    ...mapMutations([
      'closeMobileMenu'
    ]),
    getBlockModifiers() {
      let bms = this.block;
      if (this.data.blockModifiers) {
        this.data.blockModifiers.forEach( (blockModifier, index) => {
          bms += ' bm-'+blockModifier;
        });
      }

      return bms;
    },
  }
}



// WEBPACK FOOTER //
// ./components/blocks/TextLink.vue